export class UnitMeasure {
  public static readonly ONE_MB = 1.0000000000000000; // Esto equivale 1 MB
  // public static readonly MB = 1.0000000000000000; // Esto equivale 1 MB
}
